import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService, LoggedInCallback } from "../services/cognito/cognito.service";
import { CognitoTokensService } from '../services/cognito/cognito-tokens.service';

@Injectable()
export class AuthenticationService implements LoggedInCallback{
  clientloggedIn = false;
 
  constructor(private router: Router, 
              private userLoginService: UserLoginService,
              private cognitoTokenService: CognitoTokensService){
  }
 
  logout() {  
    this.userLoginService.isAuthenticated(this);
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("talentPageIndex");
    localStorage.clear();
    if((window.location.hash != "#/pages/privacy-policy") && (window.location.hash != "#/pages/cookie-policy") && (window.location.hash != "#/pages/user-terms-conditions") && (window.location.hash != "#/pages/security-policy")){
    this.router.navigate(['pages/login']);
  }
  }

  checkCredentials() {
    if (localStorage.getItem("user") === null){
        this.router.navigate(['pages/login']);
    }
  } 
    isAuthenticated(){
    if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "client") {
      this.clientloggedIn = this.cognitoTokenService.checkTokenExpiry();
    } else {
      this.clientloggedIn = false;
    }
    const promise = new Promise(
      (resolve, reject) =>{
        setTimeout(() => {          
          resolve(this.clientloggedIn)
        } ,800);
      });
    return promise;
  }
  isLoggedIn(message: string, isLoggedIn: boolean) {
      if (isLoggedIn) {
        this.userLoginService.logout();       
      }    
  }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts